import { Frequency as GalaxyFrequency } from '@vendasta/galaxy/frequency';
import { InventoryItemWithPricing } from '../common/inventory-item';
import { ItemRetailPrice, ItemWholesalePrice } from '../common/item-price';

export type ItemRow = InventoryItemWithPricing & {
  wholesalePricing: ItemWholesalePrice;
  retailPricing: ItemRetailPrice;
  fees: ItemFeeRow[];
  isMultiactivatable?: boolean;
  retailChangeConfirmed?: boolean;
  billingTerm?: BillingTerm;
  index?: number;
};

export interface ItemFeeRow {
  type: 'setup' | 'management';
  label: string;
  amountType: 'fixed' | 'percentage';
  retailAmount?: number;
  wholesaleAmount: number;
  retailAmountTotal?: number;
  frequency: GalaxyFrequency;
}

export interface PriceSummary {
  oneTime: number;
  monthly: number;
  yearly: number;
  currency: string;
}

export interface PriceTotal {
  wholesaleTotal: PriceSummary;
  retailTotal: PriceSummary;
  initialized: boolean; // controls the loading state of the summary component
}

export interface BillingTerm {
  startDate?: Date;
  endDate?: Date;
}

export interface ItemRowChangeEvent {
  item: ItemRow;
  action: ItemRowChangeEventAction;
}

export type ItemRowChangeEventAction = 'add' | 'update' | 'delete' | 'add-billing-term' | 'edit-billing-term';

export const WHOLESALE_PRICING_CONTEXT = 'wholesale';
export const RETAIL_PRICING_CONTEXT = 'retail';
